import {Injectable} from '@angular/core';
import {ZendeskSupportService} from 'src/app/ui/customer-profile/zendesk-support/zendesk-support.service';
import {LocalStorageManager} from 'src/app/data/manager/local-storage/local-storage.manager';
import {ConfigurationManager} from 'src/app/data/manager/configuration/configuration.manager';
import {SessionStorageManager} from 'src/app/data/manager/session-storage/session-storage.manager';
import {ZendeskTickesInterface} from 'src/app/data/networking/models/support/support';
import {SupportManager} from 'src/app/data/manager/support/support.manager';
import {delay} from 'rxjs/operators';
import {FirebaseFlags} from 'src/app/data/networking/models/firebase/response/flags';
import {FirebaseManager} from 'src/app/data/manager/firebase/firebase.manager';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SupportVm {
    hasNotification = false;

    zendeskURLRequests = 'https://farmatodo1393.zendesk.com/hc/es-419/requests';

    constructor(
        private lms: LocalStorageManager,
        private ssm: SessionStorageManager,
        private zendeskSupportService: ZendeskSupportService,
        private configurationManager: ConfigurationManager,
        private supportManager: SupportManager,
        private firebaseManager: FirebaseManager,
    ) {
      if (this.sessionActive() && !this.isKustomerChatActive()) {
        this.getTickets();
      }
    }

    get onScriptLoaded() { 
      return this.supportManager.onScriptLoaded.asObservable()
        .pipe(delay(800)); 
    }

    sessionActive() {
        return this.lms.has('customer');
    }

    getSupportConfig(): any {
      const supportConfig = this.ssm.get('multiCountry');
      return (supportConfig && supportConfig.support) ? supportConfig.support : {};
    }

    getUser() { return this.lms.get('customer'); }

    getTickets() {
      this.zendeskSupportService.listTickets(this.getUser().id).then(
        (results: ZendeskTickesInterface[]) => {
          if (results.length > 0) {
            const ticketsIds = results.map(tck => tck.ticketId);
            this.zendeskSupportService.getNanyTickets(ticketsIds)
              .then(
                (tickets: any[]) => {
                  let pending = 0;
                  for (const ticket of tickets) {
                    if (ticket.status === 'pending') { pending++; }
                  }
                  this.hasNotification = (pending > 0);
                },
              );
          }
        },
      );
    }

    getConfiguration(): any {
      return this.configurationManager.getConfigurationModule('support');
    }
    isKustomerChatActive(){ return  this.supportManager.isKustomerChatActive()} 
    openChat(idOrder = null) { this.supportManager.openChat(idOrder); } 

  getRemoteConfig(): Observable<FirebaseFlags> {
    return this.firebaseManager.getRemoteConfig();
  }
}
